import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';
import { RadioListItem } from './RadioListItem';
import { FormButton } from './FormButton';

interface LanguageScreenProps {
  onBack: () => void;
  onSave: (language: string) => void;
  currentLanguage?: string;
}

export const LanguageScreen = ({
  onBack,
  onSave,
  currentLanguage = 'Español',
}: LanguageScreenProps) => {
  const [selected, setSelected] = useState(currentLanguage);
  const [loading, setLoading] = useState(false);

  const languages = [
    { value: 'Español', label: 'Español', code: 'ES' },
    { value: 'English', label: 'English', code: 'EN' },
  ];

  const handleSave = () => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      onSave(selected);
      onBack();
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Idioma</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        <div className="bg-white rounded-[16px] border border-[#E5E7EB] overflow-hidden divide-y divide-[#E5E7EB]">
          {languages.map((lang) => (
            <RadioListItem
              key={lang.value}
              title={lang.label}
              subtitle={lang.code}
              selected={selected === lang.value}
              onClick={() => setSelected(lang.value)}
            />
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-[12px] p-3">
          <p className="text-xs text-[#6B7280] text-center">
            Puedes cambiarlo cuando quieras desde Configuración
          </p>
        </div>

        <FormButton
          onClick={handleSave}
          loading={loading}
        >
          Guardar
        </FormButton>
      </div>
    </div>
  );
};
